var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "container is-fluid" }, [
      _c(
        "div",
        { staticClass: "columns" },
        [
          _c(
            "b-button",
            {
              attrs: { "icon-left": "arrow-left" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t(`customer.shipping_file_manager.back`)) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c(
              "b-table",
              {
                attrs: {
                  "per-page": 10,
                  narrowed: true,
                  striped: true,
                  paginated: true,
                  loading: _vm.isLoading,
                  data: _vm.files,
                  hoverable: true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (props) {
                      return [
                        !!props.column.meta
                          ? _c(
                              "b-tooltip",
                              {
                                attrs: {
                                  active: !!props.column.meta,
                                  label: props.column.meta,
                                  type: "is-dark",
                                  dashed: "",
                                },
                              },
                              [[_vm._v(_vm._s(props.column.label))]],
                              2
                            )
                          : _c("span", [_vm._v(_vm._s(props.column.label))]),
                      ]
                    },
                  },
                ]),
              },
              [
                _c("b-table-column", {
                  attrs: {
                    field: "fileName",
                    label: _vm.$t(`customer.shipping_file_manager.file_name`),
                    sortable: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _vm._v(" " + _vm._s(props.row.originalName) + " "),
                        ]
                      },
                    },
                  ]),
                }),
                _c("b-table-column", {
                  attrs: {
                    field: "uploadDate",
                    label: _vm.$t(`customer.shipping_file_manager.upload_date`),
                    sortable: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .$dayjs(props.row.uploadDate)
                                  .format("YYYY-MM-DD")
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("b-table-column", {
                  attrs: {
                    field: "status",
                    label: _vm.$t(`customer.shipping_file_manager.status`),
                    sortable: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [_vm._v(" " + _vm._s(props.row.status) + " ")]
                      },
                    },
                  ]),
                }),
                _c("b-table-column", {
                  attrs: {
                    field: "actions",
                    label: _vm.$t("customer.shipping_file_manager.actions"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          [
                            _c("span", { staticClass: "field is-grouped" }, [
                              _c("p", { staticClass: "control" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "button is-small is-danger is-outlined",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteFile(props.row.id)
                                      },
                                    },
                                  },
                                  [
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            `customer.shipping_file_manager.delete`
                                          )
                                        )
                                      ),
                                    ],
                                  ],
                                  2
                                ),
                              ]),
                              _c("p", { staticClass: "control" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "button is-small is-info",
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadFile(
                                          props.row.id,
                                          props.row.originalName
                                        )
                                      },
                                    },
                                  },
                                  [
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            `customer.shipping_file_manager.download`
                                          )
                                        )
                                      ),
                                    ],
                                  ],
                                  2
                                ),
                              ]),
                            ]),
                          ],
                        ]
                      },
                    },
                  ]),
                }),
                _c("template", { slot: "empty" }, [_c("nothing-here")], 1),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }